import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  allForums: [],
  loading: false,
  error: false,
};

export const forumReducer = createReducer(initialState, (builder) => {
  builder
    // Get All Forum
    .addCase("getAllForumsRequest", (state, action) => {
      state.loading = true;
    })
    .addCase("getAllForumsSuccess", (state, action) => {
      state.loading = false;
      state.allForums = action.payload;
    })
    .addCase("getAllForumsFailure", (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
});
